export const AI_RISK_LEVEL_ORDER = [
    "prohibited",
    "high_risk",
    "limited_risk",
    "minimal_risk",
];

export const AI_RISK_LEVEL_COLOR = {
    prohibited: "#822626",
    high_risk: "#FF4949",
    limited_risk: "#FFA049",
    minimal_risk: "#59C94F",
};

/** Same palette as `AI_RISK_LEVEL_COLOR`, in prohibited → high → limited → minimal order (Figma). */
export const AI_RISK_LEVEL_COLORS_ORDERED = AI_RISK_LEVEL_ORDER.map(
    (key) => AI_RISK_LEVEL_COLOR[key]
);

/** Typical `riskLevel` / display labels from API or UI (aligned with Figma risk colors). */
export const AI_RISK_LEVEL_COLOR_BY_LABEL = {
    Prohibited: AI_RISK_LEVEL_COLOR.prohibited,
    High: AI_RISK_LEVEL_COLOR.high_risk,
    Limited: AI_RISK_LEVEL_COLOR.limited_risk,
    Minimal: AI_RISK_LEVEL_COLOR.minimal_risk,
};

export const AI_RISK_LEVEL_TITLE = {
    prohibited: "Prohibited",
    high_risk: "High",
    limited_risk: "Limited",
    minimal_risk: "Minimal",
};

export const AI_TASK_STATUS_ORDER = [
    "NEW",
    "IN_PROGRESS",
    "REVIEW",
    "CLOSED",
    "DELETED",
];

export const AI_TASK_STATUS_COLOR = {
    NEW: "#FFEE93",
    IN_PROGRESS: "#8792E8",
    REVIEW: "#85FF8A",
    CLOSED: "#EDECEC",
    DELETED: "#FFDADA",
};

export const AI_TASK_PRIORITY_ORDER = ["high", "medium", "low"];

export const AI_TASK_PRIORITY_COLOR = {
    high: "#DC3545",
    medium: "#FCC34B",
    low: "#1CBB8C",
};

export const sortAiRiskDistributionItems = (items) => {
    if (!Array.isArray(items)) {
        return [];
    }
    const byLevel = Object.fromEntries(items.map((row) => [row.level, row]));
    return AI_RISK_LEVEL_ORDER.map((key) => byLevel[key]).filter(Boolean);
};
